import React from 'react'

function VirtualReality() {
  return (
    <div>
        <div className="container mx-auto px-4 py-24">
      <div className="bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-4">
          Unlock the Future of Reality
        </h1>
        <p className="text-lg text-gray-700 mb-6">
          Join our Virtual Reality Development Program and embark on a journey to create immersive experiences that change the world!
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">What is Virtual Reality Development?</h2>
        <p className="text-gray-700 mb-6">
          Virtual Reality (VR) Development is the process of designing, building, and deploying immersive experiences that simulate real-world environments, interactions, and emotions.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Virtual Reality Development?</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>High demand for VR developers across industries (gaming, healthcare, education, architecture)</li>
          <li>Competitive salaries and benefits</li>
          <li>Opportunities for innovation and entrepreneurship</li>
          <li>Transform industries and lives with immersive technologies</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Virtual Reality Development Program</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>VR fundamentals and history</li>
          <li>3D modeling and texturing</li>
          <li>VR programming languages (C#, Java, Python)</li>
          <li>VR engines (Unity, Unreal Engine)</li>
          <li>AR and MR development</li>
          <li>Emerging trends: AI, IoT, and more</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Training Roadmap</h2>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 1: Foundations (3 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Introduction to VR and AR</li>
          <li>3D Modeling and Texturing (Blender, Maya)</li>
          <li>VR Programming (C#, Java)</li>
          <li>VR Engines (Unity, Unreal Engine)</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 2: Intermediate (6 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>VR Experience Design</li>
          <li>VR Interaction and Interface Design</li>
          <li>VR Audio and Sound Design</li>
          <li>VR Deployment and Optimization</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 3: Advanced (9 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Advanced VR Programming (AI, ML)</li>
          <li>VR Analytics and Performance Optimization</li>
          <li>VR Security and Safety Considerations</li>
          <li>Emerging Trends (Light Field, Holographic Displays)</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 4: Specialization (3 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Choose from: VR Gaming, VR Training, or VR Healthcare</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Certifications</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Certified VR Developer (CVRD)</li>
          <li>Unity Certified Developer</li>
          <li>Unreal Engine Certified Developer</li>
          <li>Oculus Certified Developer</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Choose Our Program?</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Industry expert instructors</li>
          <li>Hands-on training and projects</li>
          <li>Flexible learning options (online, offline)</li>
          <li>Career support and placement assistance</li>
          <li>Access to VR lab and equipment</li>
        </ul>

        <div className="mt-8 text-center">
          <p className="text-lg font-semibold text-gray-800">Get Ready to Revolutionize Reality!</p>
          <p className="text-gray-700 mb-2">Contact us to learn more and enroll today!</p>
          <p className="text-gray-700">
            <strong>Email:</strong> vrdevelopment@techeraafrica.com <br />
            <strong>Phone:</strong> 080 22632222
          </p>
          <a
            href="/brochure"
            className="mt-4 inline-block bg-blue-600 text-white font-semibold py-2 px-6 rounded-md shadow hover:bg-blue-700"
          >
            Download Our Brochure
          </a>
        </div>
      </div>
    </div>
    </div>
  )
}

export default VirtualReality